var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "doctype-modal",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("u-confirm", { ref: "confirm", attrs: { id: "delete-doctype" } }),
      _c(
        "c-sidesheet",
        {
          attrs: {
            active: _vm.active,
            title: _vm.id ? "Редактирование типа анализа" : "Новый тип анализа",
          },
          on: { close: _vm.close },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _vm.id
                    ? _c(
                        "div",
                        { staticClass: "layout-header-action" },
                        [
                          _c("c-button-2", {
                            attrs: {
                              size: "small",
                              label: "Удалить",
                              disabled: !_vm.canDeleteType,
                              icon: {
                                icon: "trash",
                                color: "secondary",
                              },
                            },
                            on: { click: _vm.deleteAnalyseType },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "doctype-form" }, [
            _c("div", { staticClass: "doctype-form" }, [
              _c(
                "div",
                { staticClass: "doctype-form__name" },
                [
                  _c("c-input-2", {
                    style: {
                      "margin-bottom":
                        _vm.submitted && _vm.nameError ? "50px" : "",
                    },
                    attrs: {
                      "floating-label": "Наименование анализа",
                      required: _vm.submitted && _vm.nameError,
                      "required-message": _vm.submitted && _vm.nameError,
                      "required-mark": true,
                      "max-length": 255,
                      clearable: true,
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "doctype-form__description" },
                [
                  _c("c-textarea", {
                    ref: "description",
                    attrs: {
                      "floating-label": "Описание",
                      type: "textarea",
                      "max-length": 500,
                      clearable: true,
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "doctype-form__actions" },
              [
                _c("c-button-2", {
                  staticClass: "doctype-form__reset",
                  attrs: { size: "large", label: "Отменить" },
                  on: { click: _vm.reset },
                }),
                _c("c-button-2", {
                  staticClass: "doctype-form__save",
                  attrs: {
                    label: "Сохранить",
                    color: "primary",
                    size: "large",
                    disabled: _vm.pending,
                  },
                  on: { click: _vm.submit },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }